import { z } from 'zod';
import { BACKEND_I18N_CODES } from '~/generated/backend-i18n-codes';

type Code = (typeof BACKEND_I18N_CODES)[number];

const divCodes = BACKEND_I18N_CODES.filter(
  (c): c is Extract<Code, `divCode_${string}`> => c.startsWith('divCode_'),
);

export const divisionCodeSchema = z.enum(divCodes);
export type DivisionCode = z.infer<typeof divisionCodeSchema>;

const bodyPartCodes = BACKEND_I18N_CODES.filter(
  (c): c is Extract<Code, `bodyPartCode_${string}`> =>
    c.startsWith('bodyPartCode_'),
);

export const bodyPartCodeI18nSchema = z.enum(bodyPartCodes);

const formCodeCategories = BACKEND_I18N_CODES.filter(
  (c): c is Extract<Code, `formCode_category_${string}`> =>
    c.startsWith('formCode_category_'),
);

const formCodeTypes = BACKEND_I18N_CODES.filter(
  (c): c is Extract<Code, `formCode_type_${string}`> =>
    c.startsWith('formCode_type_'),
);

const formCodeTypeSchema = z.enum(formCodeTypes);

export type FormCodeType = z.infer<typeof formCodeTypeSchema>;

const categoryDisplayNames = [
  ...formCodeCategories,
  ...formCodeTypes,
  ...divCodes,
];

export const categoryDisplaySchema = z.enum(categoryDisplayNames);
export type CategoryDisplayType = z.infer<typeof categoryDisplaySchema>;

const genderCodes = BACKEND_I18N_CODES.filter(
  (c): c is Extract<Code, `gender_${string}`> => c.startsWith('gender_'),
);

export const genderCodeSchema = z.enum(genderCodes);
export type GenderCode = z.infer<typeof genderCodeSchema>;

const canerScreeningStatus = BACKEND_I18N_CODES.filter(
  (c): c is Extract<Code, `cancerScreening_${string}`> =>
    c.startsWith('cancerScreening_'),
);

export const cancerScreeningStatusSchema = z.enum(canerScreeningStatus);
export type CancerScreeningStatus = z.infer<typeof cancerScreeningStatusSchema>;
